module.exports = __webpack_public_path__ + "img/1f4072cb83d28bf95b03f95dbdf76522.png";